module.exports = __webpack_public_path__ + "static/media/garage.fcf1bc62.png";